import type { TDcDraft, IPaymentSystemsData } from '@alfa-bank/site-dc-draft/src/models';

import type { IDcCard, TDcFormShort, IDcCards } from '../models';

/**
 * Конвертирует конфиг карт новой формы в старый конфиг для черновиков.
 * Можно будет удалить когда переедем с dc-form и порефачим черновик
 */
export function convertCardsConfig(cards: TDcFormShort['cards']) {
    const newConfig: TDcDraft['cards'] = [];

    /** Если в конфиге только одна карта, сразу отдаём её в нужном формате */
    if (cards.cardId) {
        const { cardId, label, packetId, prefillContractId } = cards as IDcCard;

        newConfig.push({
            label: label,
            id: prefillContractId,
            cardId: { mir: cardId },
            packetId: { mir: packetId },
        });

        return newConfig;
    }

    Object.keys(cards).forEach((paySystem: string) => {
        const paymentSystem = paySystem as keyof IPaymentSystemsData;

        (cards as IDcCards)[paySystem].forEach(card => {
            const {
                cardParams: { cardId, packetId, prefillContractId },
                ...rest
            } = card;
            const findCardIndex = newConfig.findIndex(item => item.id === prefillContractId);

            if (findCardIndex === -1) {
                newConfig.push({
                    ...rest,
                    id: prefillContractId,
                    cardId: { [paymentSystem]: cardId },
                    packetId: { [paymentSystem]: packetId },
                });
            } else {
                newConfig[findCardIndex].cardId[paymentSystem] = cardId;
                newConfig[findCardIndex].packetId[paymentSystem] = packetId;
            }
        });
    });

    return newConfig;
}

export const getCardParams = (cards: IDcCard | IDcCards, paymentSystem = 'mir', initCard = 0) => {
    const cardParams = cards.cardId
        ? (cards as IDcCard)
        : (cards as IDcCards)[paymentSystem][initCard].cardParams;
    const { cardId, packetId, prefillContractId } = cardParams;

    return { cardId, packetId, prefillContractId };
};
